<ul class="sub-menu-v2 active">
    <sidebar2-menulock-angular *ngIf="!layoutService.isMobile()"> </sidebar2-menulock-angular>

    <li class="active sidebar2-checkbox-dropdown" [class.open]="dropdownOpen" [ngClass]="dropDownClasses">
        <header *ngIf="!layoutService.isMobile()" (click)="headerLink()" class="sub-menu-v2--header">
            <label>{{ 'catalogues.catalogues' | translate }}</label>
            <i class="icon-ic-chevron-s1 icon-ic-chevron--expandable"></i>
        </header>

        <ul class="sub-menu-v2--dropdown">
            <!-- All -->
            <li [ngClass]="{ 'dropdown-item-zero': numOfCatalogues + numOfRecipes === 0 }">
                <input
                    legacy-css
                    type="checkbox"
                    [checked]="selections.allChecked"
                    (click)="toggleSelection('allChecked')"
                    class="sub-menu-v2-cb"
                    id="catalogues_all"
                    name="catalogues_all" />
                <label for="catalogues_all"
                    >All
                    <span class="badge badge-stats pull-right"> {{ numOfCatalogues + numOfRecipes }} </span>
                </label>
            </li>

            <!-- Item Catalogues -->
            <li [ngClass]="{ 'dropdown-item-zero': numOfCatalogues === 0 }">
                <input
                    legacy-css
                    type="checkbox"
                    [checked]="selections.itemCataloguesChecked"
                    (click)="toggleSelection('itemCataloguesChecked')"
                    class="sub-menu-v2-cb"
                    id="catalogues_item"
                    name="catalogues_item" />
                <label for="catalogues_item"
                    >Item {{ 'catalogues.catalogues' | translate }}
                    <span class="badge badge-stats pull-right"> {{ numOfCatalogues }} </span>
                </label>
            </li>

            <!-- Recipe Catalogues -->
            <li [ngClass]="{ 'dropdown-item-zero': numOfRecipes === 0 }">
                <input
                    legacy-css
                    type="checkbox"
                    [checked]="selections.recipeCataloguesChecked"
                    (click)="toggleSelection('recipeCataloguesChecked')"
                    class="sub-menu-v2-cb"
                    id="catalogues_recipe"
                    name="catalogues_recipe" />
                <label for="catalogues_recipe"
                    >{{ 'general.recipe' | translate }} {{ 'catalogues.catalogues' | translate }}
                    <span class="badge badge-stats pull-right"> {{ numOfRecipes }} </span>
                </label>
            </li>
        </ul>
    </li>
</ul>
